exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.custom-line[data-v-c186ca1e] {\n  border: none;\n  border-top: 1px solid #000; /* Change color and thickness */\n  margin: 10px 0; /* Adjust spacing around the line */\n}\n\n", ""]);

// exports
